import React, { useState, useEffect } from 'react'
import styles from './simpleSlider.module.scss'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { NavLink } from 'react-router-dom'
import { getAuthorName } from '../../../helpers/helpers'

interface SimpleSliderProps {
  title: string
  items: any
  category: any
}

const SimpleSlider = ({ title, items, category }: SimpleSliderProps) => {
  useEffect(() => {}, [items])

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 10,
      slidesToSlide: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 8,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 850 },
      items: 7,
      slidesToSlide: 1,
    },
    mobileBigest: {
      breakpoint: { max: 850, min: 750 },
      items: 6,
    },
    mobileBiger: {
      breakpoint: { max: 750, min: 600 },
      items: 5,
    },
    mobileBig: {
      breakpoint: { max: 600, min: 200 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 470, min: 200 },
      items: 3,
    },
    mobileSmall: {
      breakpoint: { max: 360, min: 0 },
      items: 2,
    },
  }

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{title}</div>
        <div className={styles.lefttriangle}></div>
        <div className={styles.righttriangle}></div>
      </div>
      {items?.length > 0 && (
        <div className={styles.sliderContainer}>
          <Carousel responsive={responsive}>
            {items?.length > 0 &&
              items.map((item: any) => {
                return (
                  <div key={item._id} className={styles.item}>
                    <NavLink to={`/${category}/${item._id}/${item.name.eng}`}>
                      <img src={item.image} alt="" />
                    </NavLink>
                    <div>{getAuthorName(item.name)}</div>
                  </div>
                )
              })}
          </Carousel>
        </div>
      )}
    </div>
  )
}

export default SimpleSlider
